module.exports = __webpack_public_path__ + "static/media/mopro-orange-logo.00c62552.png";